export const getSettingsQuery = () => {
    return `
        query{
            generalSettings{
            companyName
            companyShortName
            address
            defaultMpesaShortcode{
                id
                shortcode
                tillNumber
                isActive
                validatePayments
                shortcodeType
                defaultAccountNumber
            }
            logo{
                id
                file
            }
            letterhead{
                id
                file
            }
            includeInMessages
            invoiceTitle
            invoiceFootnote
            customerAccount{
                id
                autoGenerateRentInvoices
                autoGenerateOtherRecurringInvoices
                alertLandlordNewTenant
                tenantPaymentReminderDates{
                    label,
                    value
                }
                leaseSmsAlertDays
                messageTypes
            }
        }
      }`
}

export const updateSettingsMutation = (params) => {
    const {
        companyName, companyShortName, includeInMessages, updateLogo, updateLetterhead,
        mpesaShortcodeType, defaultAccountNumber, mpesaShortcode, tillNumber,
        validatePayments, autoGenerateRentInvoices, autoGenerateOtherRecurringInvoices,
        alertLandlordNewTenant, address, tenantPaymentReminderDates, leaseSmsAlertDays, accountType, messageTypes,
        invoiceTitle, invoiceFootnote
    } = params;
    let mutation = `
        mutation($logo: Upload, $letterhead: Upload){
            updateSettings(
                companyName: "${companyName}",
                companyShortName: "${companyShortName}",
                includeInMessages: ${includeInMessages},
                mpesaShortcodeType: "${mpesaShortcodeType}",
                defaultAccountNumber: "${defaultAccountNumber}",
                mpesaShortcode: "${mpesaShortcode}",
                tillNumber: "${tillNumber}",
                validatePayments: ${validatePayments},
                autoGenerateRentInvoices: ${autoGenerateRentInvoices},
                autoGenerateOtherRecurringInvoices: ${autoGenerateOtherRecurringInvoices},
                alertLandlordNewTenant: ${alertLandlordNewTenant},
                logo: $logo,
                updateLogo: ${updateLogo},
                letterhead: $letterhead,
                updateLetterhead: ${updateLetterhead},
                address: ${JSON.stringify(address)},
                tenantPaymentReminderDates:${JSON.stringify(tenantPaymentReminderDates)},
                leaseSmsAlertDays:${JSON.stringify(leaseSmsAlertDays)},
                messageTypes:${JSON.stringify(messageTypes || [])},
                accountType: "${accountType}",
                invoiceTitle: ${JSON.stringify(invoiceTitle != null ? invoiceTitle : '')},
                invoiceFootnote: ${JSON.stringify(invoiceFootnote != null ? invoiceFootnote : '')}
            ){
                company{
                    companyName
                    companyShortName
                    address
                    defaultMpesaShortcode{
                        id
                        shortcode
                        tillNumber
                        isActive
                        validatePayments
                        shortcodeType
                        defaultAccountNumber
                    }
                    includeInMessages
                    invoiceTitle
                    invoiceFootnote
                    customerAccount{
                        id
                        autoGenerateRentInvoices
                        autoGenerateOtherRecurringInvoices
                        alertLandlordNewTenant
                        accountType
                        tenantPaymentReminderDates{
                            label,
                            value
                        }
                        leaseSmsAlertDays
                        messageTypes
                    }
                    logo{
                        id
                        file
                    }
                    letterhead{
                        id
                        file
                    }
                }
                error{
                    code
                    message
                }
            }
        }
    `
    return mutation
}